// src/components/store/sections/testimonials/TestimonialV49CardsliderFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV49CardsliderFuchsiaGlow(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={49}
      archKey="card_slider"
      archLabel="Review Card Carousel"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
